import { request } from './fetch';

// 商户管理
export const getShopInfo = config => request('get',`/business/merchant/get/${config}`) // 查询商户详情
export const getShopPersonnelList = config => request('get', '/business/merchant/list/tree', config) // 查询商户列表
export const getShopList = config => request('get', '/business/merchant/shop', config) // 所属店铺查询
export const insertOrUpdate = config => request('post', '/business/merchant/insertOrUpdate', config) // 商户添加或修改
export const permissions = config => request('post', '/business/merchant/insertModule', config) // 商户授权
export const updatePosition = config => request('post', '/business/merchant/updatePosition', config) // 商户升职或离职
// export const getAllModuleList = config => request('get', '/business/merchant/getAllModule', config) // 查询店长的权限
export const updateModule = config => request('put', '/system/user/module/replace', config) // 更新店长的权限
export const getAllModuleList = config => request('get', '/system/user/module/assistant/manager', config) // 查询店长的权限
export const getAllMenuList = config => request('get', '/system/user/module/tree', config) // 查询运营的权限菜单树
export const deleteShop = config => request('delete',`/business/merchant/delete/${config}`) // 查询商户详情
export const shopSynchronize = () => request('put',`/business/shop/sync/shop`) // 商户同步
export const dynamicModule = (method,config) => request(method,'/system/user/module/dynamic',config) // 动态权限
export const shopDynamicModule = (config) => request('get','/system/user/module/dynamic/shop',config) // 获取商户的动态权限
export const batchDynamicWarrant = (method,config) => request(method,'/system/user/module/dynamic/batch',config,method==='delete'?'json':'') //动态表单批量授权&批量取消授权
export const batchNormalWarrant = (method,config) => request(method,'/system/user/module/batch',config,method==='delete'?'json':'') //非动态表单批量授权&批量取消授权

export const getShopListV2 = config => request('get', '/business/shop/list/v2', config) // 店铺列表V2

// 押金设置
export const getDeposit = config => request('get', `/business/deposit/get/${config}`) // 押金设置查询
export const setDeposit = config => request('post', '/business/deposit/update', config) // 押金设置编辑

// 字段表查询

export const getSysDictList = config => request('get', '/system/sysDict/list', config) // 所属店铺查询

